export const AUTH_ERROR_CODES = [401];

export const SYNC_FAILURE_CODES = [401, 422];
